import React from 'react';
import ReactDOM from 'react-dom/client';
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap/dist/js/bootstrap.bundle.min.js"
import "./assets/css/custom.css";

import { BrowserRouter } from 'react-router-dom';
import App from './App';



 ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
<BrowserRouter basename="/">
     <App />
    </BrowserRouter>
   
  </React.StrictMode>
)



